import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appRoutes } from './app.routes';
import { MaterialModule } from './material-module';
import { provideNativeDateAdapter } from '@angular/material/core';
import { authInterceptor } from './interceptors/auth.interceptor';
import { AuthTokenService } from './services/auth-token.service';

// ============================================
// TOKEN INITIALIZATION FUNCTION
// Fetches authentication token before app starts
// ============================================
export function initializeToken(authTokenService: AuthTokenService) {
  return () => {
    console.log('🚀 Initializing authentication token...');
    return authTokenService.initialize();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(BrowserAnimationsModule, MaterialModule),
    provideNativeDateAdapter(),
    // ============================================
    // APP_INITIALIZER: Fetches token before app starts
    // ============================================
    {
      provide: APP_INITIALIZER,
      useFactory: initializeToken,
      deps: [AuthTokenService],
      multi: true
    }
  ],
};
